const translations = {
  "en": {
    "Feel free to ask me anything about investing...": "Try asking me any investment questions..."
  },
  "zh-tw": {
    "Feel free to ask me anything about investing...": "歡迎隨時向我詢問任何有關投資的問題..."
  }
};

export default translations;
